import Column from '../../../../components/UI/Containers/Column';
import { Check } from 'lucide-react';
import { cn } from '../../../../utils';
import { HeaderText } from '../../../../components/UI/Typography/PageHeader';
const ProgressBarStep = ({
  text,
  isAccomplished,
  onClick,
}: {
  text: string;
  isAccomplished: boolean;
  onClick?: () => void;
}) => {
  return (
    <Column
      onClick={onClick}
      className="items-center justify-center mt-5 cursor-pointer"
    >
      <div
        className={cn(
          'w-11 h-11 rounded-full centerDiv',
          isAccomplished ? 'bg-primaryGreen' : 'border-2 border-borderColor bg-white'
        )}
      >
        {isAccomplished && <Check className="w-7 h-7 text-white" />}
      </div>

      <HeaderText
        title={text}
        className={cn(
          'text-sm',
          isAccomplished ? 'text-primaryGreen' : 'text-barTextColor'
        )}
      />
    </Column>
  );
};

export default ProgressBarStep;
